import { ProveedorToast } from '@reparto/ui';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { AvisoVersion } from './componentes/AvisoVersion';
import { escucharInstalacion } from './datos/instalar';
import { iniciarTiempoReal } from './datos/tiempo-real';
import { iniciarVendedor } from './datos/vendedor';
import './estilos.css';

escucharInstalacion();
// Mensajes y avisos de los pedidos en vivo, con la sesión de la tienda (decisión D53).
iniciarTiempoReal();
// Modo vendedor (decisión D60): lo que el preventista guardó sin señal se manda solo al volver.
iniciarVendedor();

createRoot(document.getElementById('raiz')!).render(
  <StrictMode>
    <ProveedorToast>
      <AvisoVersion />
      <App />
    </ProveedorToast>
  </StrictMode>,
);
